import { FC } from 'react'
import { VStack, Flex } from '@chakra-ui/react'
import NavBar from 'components/NavBar'
import RequestsDesignContent from 'pages/requestsDesign/RequestsDesignContent'

const RequestsDesign: FC = () => {
  return (
    <VStack h='full' w='full'>
      <NavBar title='Requests design' />
      <Flex
        direction={'column'}
        w='full'
        justify={'flex-start'}
        overflow={'hidden'}
        flex={1}
      >
        <RequestsDesignContent />
      </Flex>
    </VStack>
  )
}

export default RequestsDesign
